var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitbucketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71356 4.53521C3.61075 4.53389 3.5089 4.5551 3.41515 4.59736C3.3214 4.63962 3.23803 4.7019 3.1709 4.77984C3.10376 4.85778 3.05449 4.94947 3.02654 5.0485C2.99858 5.14752 2.99263 5.25147 3.00909 5.35304L5.9996 23.5214C6.03686 23.7437 6.1512 23.9458 6.32255 24.0921C6.4939 24.2385 6.7113 24.3197 6.93655 24.3216H21.2833C21.4521 24.3237 21.6161 24.2651 21.7454 24.1564C21.8748 24.0477 21.9607 23.8962 21.9877 23.7293L24.9853 5.36009C25.0018 5.25852 24.9958 5.15457 24.9678 5.05555C24.9399 4.95653 24.8906 4.86483 24.8235 4.78689C24.7563 4.70895 24.673 4.64667 24.5792 4.60441C24.4855 4.56215 24.3836 4.54094 24.2808 4.54227L3.71356 4.53521ZM16.3061 17.6662H11.727L10.4871 11.1871H17.4157L16.3061 17.6662Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0274 11.187H17.4159L16.3063 17.6661H11.7272L6.32031 24.0924C6.49169 24.2407 6.71018 24.3231 6.93673 24.325H21.287C21.4558 24.3272 21.6198 24.2686 21.7491 24.1599C21.8784 24.0512 21.9644 23.8996 21.9914 23.7328L24.0274 11.187Z",
    fill: "url(#paint0_linear_767_487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_767_487",
    x1: 25.5561,
    y1: 12.9989,
    x2: 14.6233,
    y2: 21.5286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucketIcon);
export default __webpack_public_path__ + "static/media/bitbucket-icon.4c681fb0.svg";
export { ForwardRef as ReactComponent };